//ToDo:
//  - При удалении обновлять кол-во строк
import { reactive, watch } from 'vue';

import { deepMerge } from '@/helpers/utils';
import Bus from '@/core/bus';

import Store from "./store";
import { getModel } from '@/tables';

import stateStore from "@/store";
import { ResultResponse, query } from '@/api/db';

interface FetchOptions {
	id: string | null;
	owner: string | null;
	page: number;
	limit: number;
	filters: any;
	orderby: any;
	searchtext: string;
}

// Класс для работы с коллекцией записей (таблицей) в базе данных
class DBStore extends Store {
	// Основные данные стора: строки, позиция, выбранные строки и т.д.
	public data: any = reactive({
		rows: [],
		position: -1,
		select: [],
		rowsSelected: false,
		rowCount: 0 // Общее количество записей в таблице (с учетом фильтров)
	});

	// Количество страниц (если есть пагинация)
	public pages = 0;

	// Опции для fetch (id, owner, фильтры, лимиты и т.д.)
	public fetchOptions: FetchOptions = {
		id: null,
		owner: null,//id - зависимого поля
		page: 0,
		limit: 0,
		filters: [],
		orderby: [],
		searchtext: ''
	};

	constructor(public name: string, config: any = {}) {
		super();

		// Получаем модель таблицы
		this.model = getModel(name);

		// Создаём состояние (поля, доступы и т.д.)
		this.createState(config);

		// Подписка на глобальное событие save-data (обновление/добавление/удаление)
		Bus.$on('save-data', (saveData: any) => {
			if (saveData.table == this.name) {
				if (!this.model.ownerField || saveData.data[this.model.ownerField] == this.owner) {
					if (saveData.newrecord) {
						if (this.model.subtable) {
							this.push(saveData.data);
						} else {
							this.unshift(saveData.data);
						}
					} else {
						this.refreshData(saveData.data);
					}
				}
			}
		});

		// Следим за изменением выбранных строк (select)
		watch(
			() => this.data.select,
			async () => {
				let i = 0;

				this.forEach((row: any) => {
					if (this.data.select.includes(row.id)) i++;
				})

				if (i > 0) {
					if (this.data.rows.length == i) {
						this.data.rowsSelected = true;
					} else {
						this.data.rowsSelected = null;
					}
				} else {
					this.data.rowsSelected = false;
				}
			},
			{
				deep: true
			}
		)
	}

	// Обновить данные строки (по ключу), если она уже есть в rows
	refreshData(data: any, setPosition = false) {
		const key = this.model.key;

		for (const row in this.data.rows) {
			if (this.data.rows[row][key] == data[key]) {
				if (setPosition) this.setPosition(Number(row));

				//Если не табличная часть, не офлайн таблица и есть sql поля, то запрашиваем представления этих полей
				if (!(this.model.subtable || this.model.offLine)) {
					for (const keyField in this.state.fields) {
						const field = this.state.fields[keyField];
						if (typeof field.type == 'object' && field.type.sql) {
							this.notion(this.name, data).then((notionData: any) => Object.assign(this.data.rows[row], notionData));

							break;
						}
					}
				}

				return Object.assign(this.data.rows[row], data);
			}
		}

		return null;
	}

	// Выбрать/снять выбор строки по id
	selectRow(data: any, select = true) {
		const id = data[this.model.key];

		if (select) {
			if (!this.data.select.includes(id)) this.data.select.push(id);
		} else {
			const index = this.data.select.indexOf(id);
			if (index != -1) this.data.select.splice(index, 1);
		}
	}

	// Получить массив выбранных строк
	getSelectedRows() {
		const result: any = [];

		this.data.select.forEach((el: any) => {
			for (const row of this.data.rows) {
				if (row[this.model.key] == el) result.push(row);
			}
		});

		return result;
	}

	// Установить текущую позицию (по индексу)
	setPosition(position: number) {
		this.data.position = this.data.rows.length > 0 && position < this.data.rows.length ? position : -1;
	}

	// Установить позицию по данным строки
	setPositionData(data: any) {
		for (const position in this.data.rows) {
			if (this.data.rows[position][this.model.key] == data[this.model.key]) {
				this.data.position = position;

				break;
			}
		}
	}

	// Добавить строку в конец (или обновить, если уже есть)
	push(data: any) {
		const result = this.refreshData(data, true);
		if (result) return result;

		const _data = this.createData(data);

		this.data.rows.push(_data);
		this.setPosition(this.data.rows.length - 1);

		return _data;
	}

	// Добавить строку в начало (или обновить, если уже есть)
	unshift(data: any) {
		const result = this.refreshData(data, true);
		if (result) return result;

		const _data = this.createData(data);

		this.data.rows.unshift(_data);
		this.setPosition(0);

		return _data;
	}

	// Загрузить массив строк (очистить старые, добавить новые)
	loadData(data: any = [], setPos = true) {
		this.clear();

		for (const row of data) {
			this.data.rows.push(this.createData(row));
		}

		if (this.data.rows.length > 0 && setPos) this.setPosition(0);

		this.state.loaded = true;
	}

	// Собрать параметры для fetch (с учётом фильтров, лимитов и т.д.)
	fetchParams(options = {}) {
		const params = deepMerge({}, this.fetchOptions, options);

		if (typeof params.filters == 'function')
			params.filters = params.filters(params.data ? params.data : this.data);

		if (!params.fields && this.state.fields)
			params.fields = this.getFetchFields();

		if (!params.id) delete params.id;
		if (!params.owner) delete params.owner;
		if (!params.limit) delete params.limit;
		if (!params.limit && !params.page) delete params.page;
		if (!params.searchtext) delete params.searchtext;

		if (params.filters.length == 0) delete params.filters;
		if (params.orderby.length == 0) delete params.orderby;

		if (this.owner) params.owner = this.owner;

		return params;
	}

	// Получить данные с сервера (fetchData)
	async fetchData(options: any = {}, setPos = true) {
		if (!(this.model.subtable || this.model.offLine)) {

			if (this.model.ownerField && !this.owner) return;

			stateStore.state.load = true;

			const data = deepMerge({
				table: this.name,
				method: 'read',
				params: this.fetchParams(options)
			});

			const response: ResultResponse = await query(data);

			if (response.complete) {
				const rows = response.data?.rows;

				if (rows) {
					this.loadData(rows, setPos);

					if (response.data.rowCount !== undefined) {
						this.data.rowCount = response.data.rowCount;
					}

					if (this.fetchOptions.limit) {
						this.pages = Math.ceil(response.data.rowCount / this.fetchOptions.limit);
					}
				}
			}

			stateStore.state.load = false;
		}

		return this.data.rows;
	}

	// Подготовить данные для сохранения (без представлений)
	dataForSave(data: any): any {
		return data.map((row: any) => this.getData(row));
	}

	// Получить текущую строку (по позиции)
	currentData() {
		return this.data.position != -1 && this.data.rows.length > 0 ? this.data.rows[this.data.position] : null;
	}

	// Очистить все строки и позицию
	clear() {
		this.data.rows.splice(0, this.data.rows.length);
		this.data.position = -1;
		this.data.rowCount = 0;

		this.clearSelected();
	}

	// Очистить выбранные строки
	clearSelected() {
		this.data.select.splice(0, this.data.select.length);
	}

	// Установить строки вручную (например, после фильтрации)
	setRows(rows: any) {
		this.clear();

		rows.forEach((row: any) => this.data.rows.push(row))
		this.data.position = this.data.rows.length > 0 ? 0 : -1;
	}

	// Удалить строку по позиции
	deleteRec(position: number) {
		if (this.files[this.data.rows[position].id]) delete this.files[this.data.rows[position].id];

		this.selectRow(this.data.rows[position].id, false);

		this.data.rows.splice(position, 1);

		this.setPosition(position > this.data.rows.length - 1 ? this.data.rows.length - 1 : position);
	}

	// Удалить строку по данным (и с сервера, если нужно)
	async deleteRecord(data: any) {
		const key = data[this.model.key];

		if (key) {
			for (const row in this.data.rows) {
				const position: number = +row;

				if (key == this.data.rows[position][this.model.key]) {
					if (this.model.subtable || this.model.offLine) {
						this.deleteRec(position);
					} else {
						const response: ResultResponse = await query({
							table: this.name,
							method: 'delete',
							data: {
								[this.model.key]: key
							}
						});

						if (response.complete) {
							this.deleteRec(position);
						}
					}
				}
			}
		}
	}

	// Перебрать все строки (аналог forEach для массива)
	forEach(callback: any) {
		this.data.rows.forEach((row: any) => callback(row));
	}
}

// Экспортируем класс для использования в других частях приложения
export default DBStore;
